function ItemDotBlueSmallComponent(props) {
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  )
    return <div className="dotBlueSmall"></div>;
  else return null;
}

export { ItemDotBlueSmallComponent };
